function Banner() {
    return (
      <>
        <section className="banner-section">
          <div className="container">
            <div className="banner-content">
              <div className="banner-content__text">
                <h2>Top Tracks. Top Cars. TOP RACING.</h2>
                <p>
                  Drive the car of <span>your</span> dreams, and drive like your <span>dreams</span>! All with expert level support.
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
  
  export default Banner;